import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * SPEC-web-planner-008 AC-24 (GAP-MEET-UX-283) — the one signal that the rep's qualification queue may have changed in
 * this tab (a decision saved, which can close a deal). The app shell computes the sidebar Queue badge once, when the
 * persona is set; it listens here and re-reads, so the badge follows a Disqualify without a reload.
 */
@Injectable({ providedIn: 'root' })
export class QueueChangeService {
    private readonly changes = new Subject<void>();

    /** Emits once per change; carries nothing, listeners re-read what they show. */
    readonly changed$: Observable<void> = this.changes.asObservable();

    notify(): void {
        this.changes.next();
    }
}
